/**
* Copyright (c) 2018 Microsoft Corporation
* Modules Registration
* THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
*/

export const componentDictionary = {};

componentDictionary['__local__|__local__|components|LoginToViewPricing'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-LoginToViewPricing' */
                'partner/components/LoginToViewPricing.component.tsx'),
            cn: '__local__-__local__-LoginToViewPricing'
        };
componentDictionary['__local__|__local__|modules|ari-search-results|components|AriSearchResultTable'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-AriSearchResultTable' */
                'partner/modules/ari-search-results/components/AriSearchResultTable.component.tsx'),
            cn: '__local__-__local__-AriSearchResultTable'
        };
componentDictionary['__local__|__local__|modules|back-order-list|components|BackOrderTable'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-BackOrderTable' */
                'partner/modules/back-order-list/components/BackOrderTable.component.tsx'),
            cn: '__local__-__local__-BackOrderTable'
        };
componentDictionary['__local__|__local__|modules|education-training|components|CourseTable'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-CourseTable' */
                'partner/modules/education-training/components/CourseTable.component.tsx'),
            cn: '__local__-__local__-CourseTable'
        };
componentDictionary['__local__|__local__|modules|gdn-invoices-list|components|invoie-payment-totals'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-invoie-payment-totals' */
                'partner/modules/gdn-invoices-list/components/invoie-payment-totals.component.tsx'),
            cn: '__local__-__local__-invoie-payment-totals'
        };
componentDictionary['__local__|__local__|modules|model-viewer|components|AriHotspotImage'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-AriHotspotImage' */
                'partner/modules/model-viewer/components/AriHotspotImage.component.tsx'),
            cn: '__local__-__local__-AriHotspotImage'
        };
componentDictionary['__local__|__local__|modules|model-viewer|components|AriPartsListTable'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-AriPartsListTable' */
                'partner/modules/model-viewer/components/AriPartsListTable.component.tsx'),
            cn: '__local__-__local__-AriPartsListTable'
        };
componentDictionary['__local__|__local__|modules|model-viewer|components|AriRow'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-AriRow' */
                'partner/modules/model-viewer/components/AriRow.component.tsx'),
            cn: '__local__-__local__-AriRow'
        };
componentDictionary['__local__|__local__|modules|model-viewer|components|assemblyDropdown'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-assemblyDropdown' */
                'partner/modules/model-viewer/components/assemblyDropdown.component.tsx'),
            cn: '__local__-__local__-assemblyDropdown'
        };
componentDictionary['__local__|__local__|themes|gardner-theme-b2c|views|components|addToCart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-addToCart' */
                'partner/themes/gardner-theme-b2c/views/components/addToCart.component.tsx'),
            cn: '__local__-__local__-addToCart'
        };
componentDictionary['__local__|__local__|themes|gardner-theme-b2c|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-carticon' */
                'partner/themes/gardner-theme-b2c/views/components/carticon.component.tsx'),
            cn: '__local__-__local__-carticon'
        };
componentDictionary['__local__|__local__|themes|gardner-theme-b2c|views|components|cartlineitem'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cartlineitem' */
                'partner/themes/gardner-theme-b2c/views/components/cartlineitem.component.tsx'),
            cn: '__local__-__local__-cartlineitem'
        };
componentDictionary['__local__|__local__|themes|gardner-theme-b2c|views|components|create-order-template'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-create-order-template' */
                'partner/themes/gardner-theme-b2c/views/components/create-order-template.component.tsx'),
            cn: '__local__-__local__-create-order-template'
        };
componentDictionary['__local__|__local__|themes|gardner-theme-b2c|views|components|price'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-price' */
                'partner/themes/gardner-theme-b2c/views/components/price.component.tsx'),
            cn: '__local__-__local__-price'
        };
componentDictionary['__local__|__local__|themes|gardner-theme-b2c|views|components|product'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product' */
                'partner/themes/gardner-theme-b2c/views/components/product.component.tsx'),
            cn: '__local__-__local__-product'
        };
componentDictionary['__local__|__local__|themes|gardner-theme-b2c|views|components|promocode'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-promocode' */
                'partner/themes/gardner-theme-b2c/views/components/promocode.component.tsx'),
            cn: '__local__-__local__-promocode'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|addToCart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-addToCart' */
                'partner/themes/gardner-theme/views/components/addToCart.component.tsx'),
            cn: '__local__-__local__-addToCart'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-carticon' */
                'partner/themes/gardner-theme/views/components/carticon.component.tsx'),
            cn: '__local__-__local__-carticon'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|cartlineitem'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cartlineitem' */
                'partner/themes/gardner-theme/views/components/cartlineitem.component.tsx'),
            cn: '__local__-__local__-cartlineitem'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|create-order-template'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-create-order-template' */
                'partner/themes/gardner-theme/views/components/create-order-template.component.tsx'),
            cn: '__local__-__local__-create-order-template'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|inventory-breakdown'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-inventory-breakdown' */
                'partner/themes/gardner-theme/views/components/inventory-breakdown.component.tsx'),
            cn: '__local__-__local__-inventory-breakdown'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|invoice-details-products'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-invoice-details-products' */
                'partner/themes/gardner-theme/views/components/invoice-details-products.component.tsx'),
            cn: '__local__-__local__-invoice-details-products'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|nav-icon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-nav-icon' */
                'partner/themes/gardner-theme/views/components/nav-icon.component.tsx'),
            cn: '__local__-__local__-nav-icon'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|order-details.container-row'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-details.container-row' */
                'partner/themes/gardner-theme/views/components/order-details.container-row.component.tsx'),
            cn: '__local__-__local__-order-details.container-row'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|order-details.no-shipment-tracking'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-details.no-shipment-tracking' */
                'partner/themes/gardner-theme/views/components/order-details.no-shipment-tracking.component.tsx'),
            cn: '__local__-__local__-order-details.no-shipment-tracking'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|order-details.shipment-tracking'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-details.shipment-tracking' */
                'partner/themes/gardner-theme/views/components/order-details.shipment-tracking.component.tsx'),
            cn: '__local__-__local__-order-details.shipment-tracking'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|price'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-price' */
                'partner/themes/gardner-theme/views/components/price.component.tsx'),
            cn: '__local__-__local__-price'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|product'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product' */
                'partner/themes/gardner-theme/views/components/product.component.tsx'),
            cn: '__local__-__local__-product'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|promocode'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-promocode' */
                'partner/themes/gardner-theme/views/components/promocode.component.tsx'),
            cn: '__local__-__local__-promocode'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|supersession-breakdown'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-supersession-breakdown' */
                'partner/themes/gardner-theme/views/components/supersession-breakdown.component.tsx'),
            cn: '__local__-__local__-supersession-breakdown'
        };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|cartlineitem'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-cartlineitem' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/cartlineitem.component.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-cartlineitem'
        };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|promocode'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-promocode' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/promocode.component.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-promocode'
        };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-header'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-header' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-header.component.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-header'
        };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-order-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-order-list' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-order-list.component.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-order-list'
        };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-order-table'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-order-table' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-order-table.component.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-order-table'
        };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-organization-wide-selector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-organization-wide-selector' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-organization-wide-selector.component.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-organization-wide-selector'
        };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-view-mode-selector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-view-mode-selector' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-view-mode-selector.component.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-view-mode-selector'
        };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-carticon' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/carticon.component.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-carticon'
        };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|cartlineitem'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-cartlineitem' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/cartlineitem.component.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-cartlineitem'
        };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|product-v2'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-product-v2' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/product-v2.component.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-product-v2'
        };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|product'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-product' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/product.component.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-product'
        };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|promocode'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-promocode' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/promocode.component.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-promocode'
        };